(function () {
    'use strict';

    function editableTitle($timeout) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/editableTitle.html',
            scope: {
                cssClass: '@?',
                title: '=',
                mode: '=?',
                save: '&',
                cancel: '&',
                siblingNames: '=',
                isInnerSection: '=?'
            },
            link: function (scope, element, attrs) {
                scope.mode = scope.mode || 'display';
                scope.siblingNames = scope.siblingNames || [];
                scope.saveTitle = function () {
                    scope.save();
                }

                scope.cancelSaveTitle = function () {
                    scope.cancel();
                }
            }
        };
    }

    editableTitle.$inject = ['$timeout'];

    angular.module('ecap.common').directive('editableTitle', editableTitle);
})();

